import {ReactNode} from 'react';
import VideocamIcon from '@mui/icons-material/Videocam';

export enum RecordState {
  Ready = 1,
  Recording,
  Processing,
  Recorded
}

export const AVATAR = (title: string | number | undefined): Record<RecordState, ReactNode> => ({
  [RecordState.Ready]: <VideocamIcon />,
  [RecordState.Recording]: title,
  [RecordState.Processing]: <VideocamIcon />,
  [RecordState.Recorded]: <VideocamIcon />
});

export const PRIMARYTEXT = {
  [RecordState.Ready]: '',
  [RecordState.Recording]:
    'shared/common:diagnosticReport.form.video.makeFollowingFacialExpression',
  [RecordState.Processing]: 'shared/common:diagnosticReport.form.video.processing',
  [RecordState.Recorded]: 'shared/common:diagnosticReport.form.video.inspectVideo'
};

export const SECONDARYTEXT = {
  [RecordState.Ready]: (): string => 'shared/common:diagnosticReport.form.video.pushOnRecord',
  [RecordState.Recording]: (title: string): string => title,
  [RecordState.Processing]: (): string => '',
  [RecordState.Recorded]: (): string => 'shared/common:diagnosticReport.form.video.inspectVideo'
};
